import { render, staticRenderFns } from "./product-app.vue?vue&type=template&id=b8d142ca&scoped=true"
import script from "./product-app.vue?vue&type=script&lang=js"
export * from "./product-app.vue?vue&type=script&lang=js"
import style0 from "./product-app.vue?vue&type=style&index=0&id=b8d142ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d142ca",
  null
  
)

export default component.exports